(function () {

 'use strict';

  angular.module('eclipseApp.core').filter('sceHtml', ['$sce', function($sce) {
    return function (escapedhtml) {
      if(escapedhtml !== null && escapedhtml !== '' && angular.isDefined(escapedhtml)){
        escapedhtml = escapedhtml.replace(/\&mdash\;/g, '');
        escapedhtml = escapedhtml.replace(/\&\#8211\;/g, '');
        escapedhtml = escapedhtml.replace(/\&\#8212\;/g, '');
        // Need to add more reference if needed - Open to Business
      }
      return $sce.trustAsHtml(escapedhtml);
    }
  }]);

})();
